import store from "@/store/index";
/**
 * @author: wyt
 * @description: 创建GSPTileLayer图层
 * @export
 * @param {*} serviceUrl 路径
 * @return {*}
 */
export function createGSPTile(serviceUrl, type) {
    var esriModule = store.state.esriModule;
    if (serviceUrl.indexOf("http://") == -1 && serviceUrl.indexOf("https://") == -1) {
        serviceUrl = "http://" + serviceUrl;
    }
    var gspTileLayer = new esriModule.GSPTileLayer(serviceUrl, type);
    return gspTileLayer;
}

/**
 * @author: wyt
 * @description: 获取颜色
 * @param {*} number
 * @return {*}
 */
export function getColor(number) {
    // const alpha = number >> 24 & 0xff;
    const alpha = 1;
    const red = (number >> 16) & 0xff;
    const green = (number >> 8) & 0xff;
    const blue = number & 0xff;
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

// 停止绘图文字
export function stopDrawText() {
    setTimeout(() => {
        store.dispatch("setDrawingText", "");
    }, 1000);
}

/**
 * @author: wyt
 * @description: 图片异步获取
 * @param {*} src 图片路径
 * @return {*}
 */
export async function loadCompleted(src) {
    return new Promise(resolve => {
        var img = new Image();
        img.src = src;
        img.crossOrigin = "Anonymous";
        img.onload = () => {
            resolve(img);
        };
    });
}

/**
 * @author: wyt
 * @description: 根据extent计算行列号 最大行列和最小行列 左下角最小
 * @export
 * @param {*} extent 范围
 * @return {*}
 */
export function getRowCol(extent) {

    var level = map.getLevel();
    var OriginX = -20037508.342787;
    var OriginY = -20037508.342787;
    if (
        extent.ymax <= 200 &&
        extent.xmax <= 360 &&
        extent.ymax >= -200 &&
        extent.xmax >= -360
    ) {
        OriginX = -180;
        OriginY = -90;
    }

    var res = map.__tileInfo.lods[level].resolution;
    var minrow = Math.floor((extent.ymin - OriginY) / (res * 256));
    var maxrow = Math.floor((extent.ymax - OriginY) / (res * 256));
    var mincol = Math.floor((extent.xmin - OriginX) / (res * 256));
    var maxcol = Math.floor((extent.xmax - OriginX) / (res * 256));
    return {
        minRow: minrow,
        maxRow: maxrow,
        minCol: mincol,
        maxCol: maxcol
    };
}

/**
 * @author: wyt
 * @description: 计算某行某列偏移
 * @export
 * @param {*} row 行号
 * @param {*} col 列号
 * @return {*}
 */
 export function getCoordByRowCol(row, col) {
    var esriModule = store.state.esriModule;
    var level = map.getLevel();
    // 原点
    var OriginX = -20037508.342787;
    var OriginY = -20037508.342787;
  
    var extent = map.extent;
  
    if (
      extent.ymax <= 200 &&
      extent.xmax <= 360 &&
      extent.ymax >= -200 &&
      extent.xmax >= -360
    ) {
      OriginX = -180;
      OriginY = -90;
    }
    // 地图分辨率
    var res = map.__tileInfo.lods[level].resolution;
    // 计算出当前分辨率行列的起始点
    var x = col * res * 256 + OriginX;
    var y = (row + 1) * res * 256 + OriginY;
  
    //像素偏移量的xy
    var offsetX = (extent.xmin - x) / res;
    var offsetY = (extent.ymin - y) / res;
  
    var point = new esriModule.Point(
      extent.xmin,
      extent.ymin,
      map.spatialReference
    );
    var screenPoint = map.toScreen(point);
    // 像素偏移量
    return {
      offsetX: screenPoint.x - offsetX,
      offsetY: screenPoint.y + offsetY
    };
  }